module.exports = __webpack_public_path__ + "static/images/trend-down-arrow-bold.bc18fe689b4d79956064999ffafa56b6.svg";